import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KeyboardBackspaceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"keyboard_backspace"}/>
}
